import { z } from 'zod';
import { PaginationPageHasMoreSchema } from './shared/pagination.js';
export const FOLLOWERS_IMPACT_SORT_FIELDS = ['impactScore', 'followersCount', 'followingCount', 'ratio'] as const;
export type FollowersImpactSortField = (typeof FOLLOWERS_IMPACT_SORT_FIELDS)[number];

export const VerifiedTypeSchema = z.enum(['none', 'blue', 'business', 'government']);
export type VerifiedType = z.infer<typeof VerifiedTypeSchema>;

export const FollowersImpactQuerySchema = z.object({
  page: z.coerce.number().int().min(0).default(0).optional(),
  limit: z.coerce.number().int().min(1).max(100).default(50).optional(),
  sortBy: z.enum(FOLLOWERS_IMPACT_SORT_FIELDS).optional(),
  sortOrder: z.enum(['asc', 'desc']).optional(),
});

export type FollowersImpactQuery = z.infer<typeof FollowersImpactQuerySchema>;

export const FollowersImpactEntrySchema = z.object({
  id: z.string(),
  username: z.string(),
  name: z.string(),
  profileImageUrl: z.string().nullable(),
  bio: z.string().nullable(),
  description: z.string().nullable(),
  followersCount: z.number(),
  followingCount: z.number(),
  ratio: z.number(),
  impactScore: z.number(),
  verifiedType: VerifiedTypeSchema.nullable(),
});

export type FollowersImpactEntry = z.infer<typeof FollowersImpactEntrySchema>;

export const FollowersImpactPaginationSchema = PaginationPageHasMoreSchema.extend({
  page: PaginationPageHasMoreSchema.shape.page.min(0),
  limit: PaginationPageHasMoreSchema.shape.limit.min(1).max(100),
  totalCount: z.number().nullable(),
});

export const FollowersImpactMetaSchema = z.object({
  lastSync: z.string().nullable(),
  isStale: z.boolean(),
  isIncomplete: z.boolean(),
  hasFullSnapshot: z.boolean(),
});

export const FollowersImpactResponseSchema = z.object({
  followers: z.array(FollowersImpactEntrySchema),
  pagination: FollowersImpactPaginationSchema,
  meta: FollowersImpactMetaSchema,
});

export type FollowersImpactResponse = z.infer<typeof FollowersImpactResponseSchema>;
